import CargoOwnerShareAccess from "components/shared/cargoOwnerShareAccess";
import differenceInHours from "date-fns/differenceInHours";
import { sortedPoints } from "helpers/bidpoint";
import { dateTimeToView } from "helpers/date";
import { paths } from "helpers/paths";
import { formatNumber, ymEvent } from "helpers/system";
import ArrowRight from "icons/planning/arrow-right.svg";
import Marker from "icons/planning/marker.svg";
import { UmamiManager } from "lib/umami";
import React from "react";
import { Link } from "react-router-dom";
import { giveAccessToBids } from "sources/books/cargoOwners";
import WithToggle from "./withToggle";

export default function CurrentBid(props) {
    const { currentBid, changeCurrentBid, compoundBids, canEditPlanning } = props;
    if (!currentBid) {
        return null;
    }
    const { from, to, route, remainingDistance, bidPoints, estimation, counterparty, id } = currentBid;

    const lastPoint = sortedPoints(bidPoints).at(-1);
    const { planEnterDateOffset } = lastPoint ?? {};

    const diffColor = (() => {
        if (!planEnterDateOffset || !estimation?.estimatedDate) {
            return "";
        }
        const diffInHours = differenceInHours(new Date(planEnterDateOffset), new Date(estimation.estimatedDate));
        if (diffInHours < 0) {
            return "text-danger";
        } else if (diffInHours > 5) {
            return "p-expanded__green-text";
        } else {
            return "text-wraning";
        }
    })();

    const openAccess = () => {
        UmamiManager.track("RouteCardShareButtonClicked");
        ymEvent("TripPlanningShareLocationClicked");

        return props.modal({
            name: "default",
            title: "Предоставление доступа к заявкам",
            CustomBody: CargoOwnerShareAccess,
            bodyData: {
                submit: giveAccessToBids,
                initialState: {
                    shareAccessEnabled: true,
                    id: counterparty.id,
                    kpp: counterparty.kpp,
                    name: counterparty.name,
                    inn: counterparty.inn,
                    kppDisabled: !!counterparty.kpp,
                    contactPerson: counterparty.contactPerson,
                },
            },
        });
    };

    return (
        <>
            <WithToggle title={<span className="p-expanded__green-text">Текущий рейс</span>}>
                <div className="p-expanded__inside-card mb-3">
                    <Link
                        to={paths.bidShow("bid", id)}
                        className="pb-1"
                        target="_blank"
                        onClick={() => {
                            ymEvent("TripPlanningRouteDetailsUsed");
                            ymEvent("TripPlanningTableUsed");
                        }}
                    >
                        {from} <ArrowRight /> <span className="font-weight-semibold pr-2">{to}</span>
                        <span className="text-nowrap">{formatNumber(Math.round(route.distance / 1000))} км.</span>
                    </Link>
                    <div>
                        Осталось пройти{" "}
                        <span className="p-expanded__green-text">
                            {formatNumber(Math.round(remainingDistance / 1000))} км.
                        </span>
                    </div>
                    <div>
                        <div className="d-inline-block pr-1">Плановая дата прибытия</div>
                        <div className="font-weight-semibold d-inline-block">
                            {dateTimeToView(planEnterDateOffset, "DD.MM.YYYY HH:mm (Z)")}
                        </div>
                    </div>
                    <div>
                        <div className="d-inline-block pr-1">Расчетная дата прибытия</div>
                        <div className={`font-weight-semibold d-inline-block ${diffColor}`}>
                            {dateTimeToView(estimation?.estimatedDate, "DD.MM.YYYY HH:mm (Z)")}
                        </div>
                    </div>
                </div>
                {counterparty && (
                    <>
                        <div className="pb-2">
                            <span className="text-muted pr-3">Контрагент</span>
                            {counterparty.name}
                        </div>
                        {canEditPlanning && (
                            <div className="d-inline-flex gap-2">
                                <span className="text-muted">Поделиться локацией с контрагентом</span>
                                <div className="planning-btn planning-btn--warning pr-3" onClick={openAccess}>
                                    <Marker />
                                    Поделиться
                                </div>
                            </div>
                        )}
                    </>
                )}
            </WithToggle>
            {compoundBids && compoundBids.length > 0 && (
                <div className="mt-2">
                    <WithToggle title="Сборные заявки">
                        <div className="p-expanded__inside-card">
                            {compoundBids.map((item) => {
                                const points = sortedPoints(item.bidPoints);
                                return (
                                    <div className="lh-14 pb-1" key={item.id}>
                                        <span className="link" onClick={() => changeCurrentBid(item)}>
                                            {item.from} - {item.to}
                                        </span>
                                        <br />
                                        <span className="small text-muted">
                                            {dateTimeToView(
                                                points.at(0).enteredAtByLogistOrAuto ??
                                                    points.at(0).planEnterDateOffset,
                                                "DD.MM.YYYY HH:mm (Z)",
                                            )}{" "}
                                            -{" "}
                                            {dateTimeToView(
                                                points.at(-1).leftAtByLogistOrAuto ??
                                                    points.at(-1).enteredAtByLogistOrAuto ??
                                                    points.at(-1).planLeaveDateOffset,
                                                "DD.MM.YYYY HH:mm (Z)",
                                            )}
                                        </span>
                                    </div>
                                );
                            })}
                        </div>
                    </WithToggle>
                </div>
            )}
        </>
    );
}
